import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, Country } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-country-list',
  templateUrl: './epbt-fa-country-list.component.html',
  styleUrls: ['./epbt-fa-country-list.component.scss']
})
export class EpbtFaCountryListComponent implements OnInit {
  @Input() countries: any;
  @Input() readonly: boolean;


  @Input()
  selectedCountryId: Country;

  @Output() selectedCountryIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  ngOnInit(): void {
    this.GetCountry();
  }

  onSelectionChange(selectedValue: any) {
    this.selectedCountryId = selectedValue;
    this.selectedCountryIdChange.emit(this.selectedCountryId);
  }
  GetCountry() {
    this.client.getBisTrackCountries().subscribe(res => {
      this.countries = res;
      if (this.countries.length > 0) {
        this.selectedCountryId = this.countries[0];
        this.selectedCountryIdChange.emit(this.countries[0]);
      }
    });
  }
}
